import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { CustomMultiselect, defaultRenderer } from '../common';
import { saveConfig, updateSelectedOptions } from '../../FilterActions';
import { OVERVIEW_WIDGETS_ARRAY } from '../../../../modules/Overview/OverviewConstants';
import { PROCESS_IMPROVEMENT_WIDGETS_ARRAY } from '../../../../modules/ProcessImprovement/ProcessImprovementConstants';

class WidgetSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedWidgets: this.getSelectedWidgets(props)
    };
  }

  componentDidMount() {
    // Widget selections are now loaded from Redux state
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedWidgets !== this.props.selectedWidgets ||
        prevProps.tempSelectedWidgets !== this.props.tempSelectedWidgets) {
      this.setState({ selectedWidgets: this.getSelectedWidgets(this.props) });
    }
  }

  getSelectedWidgets = (props) => {
    const widgets = props.isProcessImprovement ? PROCESS_IMPROVEMENT_WIDGETS_ARRAY : OVERVIEW_WIDGETS_ARRAY;
    const defaultSelection = widgets.map(widget => widget.value);

    // Treat empty array as needing default selection
    if (props.tempSelectedWidgets && props.tempSelectedWidgets.length > 0) {
      return props.tempSelectedWidgets;
    }

    if (props.selectedWidgets && props.selectedWidgets.length > 0) {
      return props.selectedWidgets;
    }

    return defaultSelection;
  };

  loadSavedSelection = () => {
    // This will now be loaded automatically from filter state when the chart loads
    return null;
  };

  saveSelection = (selectedValues) => {
    const { updateSelectedOptions, saveConfig, isProcessImprovement } = this.props;
    if (!updateSelectedOptions) return;
    
    const chartType = isProcessImprovement ? 'process' : 'overview';
    
    console.log('WidgetSelector - Saving selection:', {
      chartType,
      selectedValues
    });
    
    updateSelectedOptions(selectedValues, chartType);
    saveConfig();
  };

  handleWidgetToggle = (selectedValues) => {
    this.setState({
      selectedWidgets: selectedValues
    });
    
    if (this.props.onTempWidgetSelectionChange) {
      this.props.onTempWidgetSelectionChange(selectedValues);
    }
  };

  render() {
    let widgets = this.props.isProcessImprovement ? PROCESS_IMPROVEMENT_WIDGETS_ARRAY : OVERVIEW_WIDGETS_ARRAY;
    
    // Filter widgets based on available widgets if provided
    if (this.props.availableWidgets && Array.isArray(this.props.availableWidgets)) {
      widgets = widgets.filter(widget => this.props.availableWidgets.includes(widget.value));
    }
    
    const { selectedWidgets } = this.state;

    return (
      <div className="widget-selector">
        <div className="widget-selector-content">
          <CustomMultiselect
            name="Widgets"
            items={widgets}
            selectedItems={selectedWidgets}
            onSelect={this.handleWidgetToggle}
            itemRenderer={defaultRenderer}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const chart = state.filters.chart;
  return {
    selectedWidgets: state.filters[chart] ? state.filters[chart].selectedWidgets : []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateSelectedOptions: (widgets, chart) => dispatch(updateSelectedOptions('widgets', widgets, chart))
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(WidgetSelector);
export { connected as WidgetSelector };